import React from 'react'
import classNames from 'classnames'
import { LandingAnimation } from '@/components/composed/landingBlocks/LandingAnimation'
import { LANDING_ANIMATION } from '@/components/composed/landingBlocks/LandingAnimation/constants'
import { addModalToWellKnown } from '@/components/composed/Modal/constants'
import { Button, Image, MetaInfo } from '@/components/ui'
import { LandingBreadcrumbs } from '../LandingBreadcrumbs'
import LandingConsultingModal from '../LandingConsultingModal'
import { ELandingHeaderAnimationDelay, LANDING_HEADER_ANIMATION_DURATION } from './constants'
import { messages } from './messages'
import type { TLandingHeaderProps } from './types'
import './styles.scss'

addModalToWellKnown({
  LandingConsultingModal,
})

export const LandingHeader: React.FC<TLandingHeaderProps> = props => {
  const {
    title,
    pageTitle,
    description,
    image,
    buttonText,
    currentPageBreadcrumb,
    rootBreadcrumbs,
    additionalButton,
    titleClassName,
    withAnimation = false,
    onClickSubmitApplication,
  } = props

  const rootFadeAnimation = {
    ...LANDING_ANIMATION.fade,
    duration: LANDING_HEADER_ANIMATION_DURATION,
    delay: ELandingHeaderAnimationDelay.WHOLE_BLOCK,
  }

  return (
    <LandingAnimation desktopTargetStyles={rootFadeAnimation} mobileTargetStyles={rootFadeAnimation} isDisabled={!withAnimation}>
      <header className="landingHeader">
        <div className="landingHeader__wrapper page-wrapper">
          <MetaInfo metaInfo={{ title: pageTitle }} />
          <LandingAnimation
            isDisabled={!withAnimation}
            desktopTargetStyles={{ ...LANDING_ANIMATION.fadeRight, delay: ELandingHeaderAnimationDelay.LEFT_BLOCK }}
            mobileTargetStyles={{
              ...LANDING_ANIMATION.fade,
              delay: ELandingHeaderAnimationDelay.LEFT_BLOCK,
            }}
          >
            <div className="landingHeader__breadcrumbs">
              <LandingBreadcrumbs currentPageBreadcrumb={currentPageBreadcrumb} rootBreadcrumbs={rootBreadcrumbs} />
            </div>
          </LandingAnimation>
          <LandingAnimation
            desktopTargetStyles={{ ...LANDING_ANIMATION.fadeRight, delay: ELandingHeaderAnimationDelay.LEFT_BLOCK }}
            isDisabled={!withAnimation}
          >
            <h1 className={classNames(titleClassName, 'landingHeader__title h2-sm')}>{title}</h1>
          </LandingAnimation>
          <LandingAnimation
            desktopTargetStyles={{ ...LANDING_ANIMATION.fadeRight, delay: ELandingHeaderAnimationDelay.LEFT_BLOCK }}
            isDisabled={!withAnimation}
          >
            <p className="landingHeader__discount">{description}</p>
          </LandingAnimation>
          <LandingAnimation
            desktopTargetStyles={{ ...LANDING_ANIMATION.fadeRight, delay: ELandingHeaderAnimationDelay.LEFT_BLOCK }}
            isDisabled={!withAnimation}
          >
            <div className="landingHeader__actions">
              <Button onClick={onClickSubmitApplication} className="landingHeader__submitApplication" modifiers={['green']}>
                {buttonText || messages.button.submitApplication}
              </Button>
              {additionalButton}
            </div>
          </LandingAnimation>
          <LandingAnimation
            desktopTargetStyles={{ ...LANDING_ANIMATION.fadeLeft, delay: ELandingHeaderAnimationDelay.RIGHT_BLOCK }}
            isDisabled={!withAnimation}
          >
            <div className="landingHeader__image">
              <Image src={image} shouldUseExactSrc />
            </div>
          </LandingAnimation>
        </div>
      </header>
    </LandingAnimation>
  )
}
